import { Directive, ElementRef, HostListener, input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[libAutoCapitalize]',
    standalone: false
})
export class AutoCapitalizeDirective {
  libAutoCapitalize = input(false);

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private control: NgControl) { }

  @HostListener('blur', ['$event'])
  onBlur(e: FocusEvent | Event): void {
    if (this.libAutoCapitalize()) {
      this.control.control?.setValue(this.control.value.toUpperCase());
    }
  }
}
